var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{style:(_vm.squareStyle),on:{"click":_vm.onClick}},[(_vm.squareType === 3)?_c('div',{style:(_vm.pawnStyle)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }